import { render } from "./BlurtingView.vue?vue&type=template&id=72ba166a&scoped=true"
import script from "./BlurtingView.vue?vue&type=script&lang=js"
export * from "./BlurtingView.vue?vue&type=script&lang=js"

import "./BlurtingView.vue?vue&type=style&index=0&id=72ba166a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ba166a"]])

export default __exports__